import React from 'react';

function Estimate(props) {
  return (
    <svg
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.1389 17.9027C15.2889 18.1012 15.4847 18.2605 15.7096 18.3669C15.9346 18.4734 16.1819 18.5237 16.4306 18.5138C17.2222 18.5138 17.8611 18.0277 17.8611 17.4374C17.8611 16.8471 17.2222 16.361 16.4306 16.361C15.6389 16.361 15 15.8819 15 15.2846C15 14.6874 15.6389 14.2152 16.4306 14.2152C16.6784 14.2056 16.925 14.2555 17.1497 14.3606C17.3744 14.4657 17.5707 14.623 17.7222 14.8194"
        stroke="#292E36"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M16.4307 18.5137V19.229"
        stroke="#292E36"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M16.4307 13.4999V14.2152"
        stroke="#292E36"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M16.375 21.375C19.1364 21.375 21.375 19.1364 21.375 16.375C21.375 13.6136 19.1364 11.375 16.375 11.375C13.6136 11.375 11.375 13.6136 11.375 16.375C11.375 19.1364 13.6136 21.375 16.375 21.375Z"
        stroke="#292E36"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M10.125 21.375H3.875C3.54348 21.375 3.22553 21.2433 2.99112 21.0089C2.7567 20.7745 2.625 20.4565 2.625 20.125V7C2.625 6.66848 2.7567 6.35053 2.99112 6.11612C3.22553 5.8817 3.54348 5.75 3.875 5.75H7C7 4.9212 7.32924 4.12634 7.91529 3.54029C8.50134 2.95424 9.2962 2.625 10.125 2.625C10.9538 2.625 11.7487 2.95424 12.3347 3.54029C12.9207 4.12634 13.25 4.9212 13.25 5.75H16.375C16.7065 5.75 17.0245 5.8817 17.2589 6.11612C17.4933 6.35053 17.625 6.66848 17.625 7V8.875"
        stroke="#292E36"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
      <path
        d="M10.125 5.75879C9.95241 5.75879 9.8125 5.61887 9.8125 5.44629C9.8125 5.2737 9.95241 5.13379 10.125 5.13379"
        stroke="#292E36"
        strokeWidth="1.25"
      />
      <path
        d="M10.125 5.75879C10.2976 5.75879 10.4375 5.61887 10.4375 5.44629C10.4375 5.2737 10.2976 5.13379 10.125 5.13379"
        stroke="#292E36"
        strokeWidth="1.25"
      />
    </svg>
  );
}

export default Estimate;
